import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ShieldCheck, Clock } from "lucide-react";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit-log").then((r) => setRows(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-muted-foreground mb-1">Governance</div>
        <h1 className="font-display text-3xl font-bold tracking-tight flex items-center gap-3">
          <ShieldCheck className="h-8 w-8 text-emerald-600" strokeWidth={1.5} /> Audit Log
        </h1>
        <p className="text-muted-foreground text-sm mt-1">Immutable, append-only record of every AI action, approval, and stage change.</p>
      </div>
      <Card className="border-border shadow-none overflow-hidden">
        <div className="divide-y divide-border">
          {rows.map((e, i) => (
            <div key={i} className="p-4 flex items-start gap-4 hover:bg-[#FAFAFA]">
              <div className="h-8 w-8 rounded-full bg-[#F4F4F5] grid place-items-center text-xs font-bold flex-shrink-0">
                {e.actor?.[0]?.toUpperCase()}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm"><span className="font-semibold font-mono">{e.actor}</span> · {e.action}</div>
                <div className="text-xs text-muted-foreground mt-1 flex items-center gap-1"><Clock className="h-3 w-3" /> {new Date(e.at).toLocaleString()}</div>
              </div>
              <Badge variant="outline" className="text-[10px] font-mono uppercase tracking-wider">Immutable</Badge>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
